var _excluded = ["theme"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { map } from '../styles/breakpoints';
// Need margin because it needs to include 'auto' for margin to work propery
import { margin as defaultSpacing } from '../styles/spacing';
export function getSpacingFromTheme(key, theme) {
  var value = theme && theme.spacing && theme.spacing[key] || defaultSpacing[key];
  if (process.env.NODE_ENV !== 'production') {
    if (typeof key === 'undefined') {
      console.error("A spacing named \"".concat(key, "\" does not exist.")); // eslint-disable-line no-console
      return '0';
    }
  }
  if (typeof value === 'number') {
    value = "".concat(value, "px");
  }
  return value;
}
export function createSpacingFunc(propName, styleTags) {
  return function spacing(_ref) {
    var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);
    var styleProp = props[propName];
    return map(styleProp, function (key) {
      if (key) {
        return styleTags.map(function (tag) {
          return "".concat(tag, ": ").concat(getSpacingFromTheme(key, theme), ";");
        });
      }
      return '';
    });
  };
}
export var setMargin = createSpacingFunc('margin', ['margin']);
export var setMarginX = createSpacingFunc('marginX', ['margin-left', 'margin-right']);
export var setMarginY = createSpacingFunc('marginY', ['margin-top', 'margin-bottom']);
export var setMarginTop = createSpacingFunc('marginTop', ['margin-top']);
export var setMarginRight = createSpacingFunc('marginRight', ['margin-right']);
export var setMarginBottom = createSpacingFunc('marginBottom', ['margin-bottom']);
export var setMarginLeft = createSpacingFunc('marginLeft', ['margin-left']);
export var setPadding = createSpacingFunc('padding', ['padding']);
export var setPaddingX = createSpacingFunc('paddingX', ['padding-left', 'padding-right']);
export var setPaddingY = createSpacingFunc('paddingY', ['padding-top', 'padding-bottom']);